import { render } from "./SupportAuditDetails.vue?vue&type=template&id=1395d4cd"
import script from "./SupportAuditDetails.vue?vue&type=script&lang=js"
export * from "./SupportAuditDetails.vue?vue&type=script&lang=js"

import "./SupportAuditDetails.vue?vue&type=style&index=0&id=1395d4cd&lang=css"

import exportComponent from "/Users/admin/Desktop/bos-vue/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__